/* Tiered "spend & save" — PERCENT model. cart progress-to-next-tier.
   window.JY_TIERS = [[min,pct],...] is injected by jy-tier-bar.liquid from the
   theme settings, floor rung first (e.g. [[0,10],[250,20],[500,25]]). Exposes
   window.JY_TIER.render(subtotalMAD) which the JS contexts (express popup / COD
   page) call on every total refresh. Pure ES5 (no ?./??), updates text + a
   reserved bar inside an already-rendered slot → no old-WebView SyntaxError, no
   CLS. State (% earned) shows in the badge when the slot has one, otherwise it
   leads the message; the message itself is the ACTION (next step). */
(function () {
  var TIERS = (window.JY_TIERS || [])
    .slice()
    .sort(function (a, b) { return a[0] - b[0]; });
  var FREE = Number(window.JY_TIER_FREESHIP || 0); /* free-shipping threshold */
  var isAr =
    document.documentElement.lang && document.documentElement.lang.indexOf('ar') === 0;
  var topMin = TIERS.length ? TIERS[TIERS.length - 1][0] : 0;

  /* store line icons (currentColor) — matches the theme, no emoji */
  var SVG_CHECK = '<svg class="jy-i jy-i--g" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var SVG_TRUCK = '<svg class="jy-i jy-i--g jy-i--truck" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4h13v11H1zM14 8h4l4 4v3h-6"/><circle cx="5" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>';

  function money(n) {
    return Math.round(n) + (isAr ? ' درهم' : ' Dhs');
  }

  function compute(sub) {
    if (!TIERS.length) return null;
    var cur = -1, i;
    for (i = 0; i < TIERS.length; i++) {
      if (sub >= TIERS[i][0]) cur = i;
    }
    var earnedPct = cur >= 0 ? TIERS[cur][1] : 0;
    var next = TIERS[cur + 1];
    if (next) {
      return { top: false, earnedPct: earnedPct, remaining: Math.max(0, next[0] - sub), nextPct: next[1] };
    }
    return { top: true, earnedPct: earnedPct, remaining: 0, nextPct: 0 };
  }

  window.JY_TIER = {
    render: function (sub, actualPct) {
      var box = document.querySelector('[data-jy-tierprog]');
      if (!box) return;
      var c = compute(sub);
      if (!c || sub <= 0) { box.hidden = true; return; }
      /* When the caller knows the REAL applied discount (order popups pass it)
         and it differs from the tier the subtotal would earn, a special rule is
         in effect — a product-specific discount (e.g. a "10% OFF" tag) that
         beats the tier, or a cap that lowers it (local products stop at 10%).
         Either way, show the REAL discount so the badge always matches the
         Remise line, and drop the "spend more, get X%" upsell (the tier ladder
         isn't what's governing this cart, so projecting it would mislead). */
      var special = false;
      if (typeof actualPct === 'number' && actualPct >= 0 && Math.abs(actualPct - c.earnedPct) >= 0.5) {
        special = true;
        c = { top: true, earnedPct: Math.round(actualPct), remaining: 0, nextPct: 0 };
      }
      box.hidden = false;
      /* absolute fill (0 → top tier) so the milestone dots line up; a settled
         special discount reads as a full, locked-in bar */
      var fill = box.querySelector('[data-jy-tierprog-fill]');
      var absPct = special ? 100 : (topMin > 0 ? Math.max(3, Math.min(100, (sub / topMin) * 100)) : 0);
      if (fill) fill.style.width = absPct + '%';
      /* check off every threshold already reached (all, when a special discount is locked in) */
      var marks = box.querySelectorAll('[data-jy-mark]');
      for (var m = 0; m < marks.length; m++) {
        var mv = parseFloat(marks[m].getAttribute('data-jy-mark')) || 0;
        marks[m].className = (special || sub >= mv) ? 'jy-tierprog__mark is-hit' : 'jy-tierprog__mark';
      }
      box.className = c.top ? 'jy-tierprog is-max' : 'jy-tierprog';
      /* state → badge if present; else it leads the message (badge-less slots) */
      var badge = box.querySelector('[data-jy-tierprog-badge]');
      if (badge) badge.innerHTML = '&minus;' + c.earnedPct + '%';
      var msg = box.querySelector('[data-jy-tierprog-msg]');
      if (!msg) return;
      if (c.top) {
        msg.innerHTML = SVG_CHECK + ' ' + (special
          ? (isAr ? 'الخصم المطبّق' : 'Remise appliquée')
          : (isAr ? 'وصلتي لأقصى خصم' : 'Réduction maximale atteinte'));
        return;
      }
      /* free shipping unlocks at FREE — fold it into the reward for the tier
         that crosses it, so 250 reads as "livraison offerte + −20%". */
      var freeAtNext = FREE > 0 && sub < FREE && (sub + c.remaining) >= FREE;
      var freeTxt = freeAtNext
        ? (SVG_TRUCK + ' <span class="jy-tierprog__free">' + (isAr ? 'توصيل فابور' : 'livraison offerte') + '</span> + ')
        : '';
      var lead = badge ? '' : ('<b>&minus;' + c.earnedPct + '%</b> · '); /* no badge → state inline */
      msg.innerHTML = isAr
        ? lead + 'زوّد <b>' + money(c.remaining) + '</b> وتربح ' + freeTxt + '<b>&minus;' + c.nextPct + '%</b>'
        : lead + 'Ajoutez <b>' + money(c.remaining) + '</b> et gagnez ' + freeTxt + '<b>&minus;' + c.nextPct + '%</b>';
    },
  };
})();
